import { useEffect, useState } from "react";
import api from "../lib/api";
import { useSettings } from "../lib/settings";
import { PlantBadge } from "../components/Bits";

export default function EmbedPlants() {
  const [plants, setPlants] = useState([]);
  const s = useSettings();

  useEffect(() => {
    api.get("/embed/plants?limit=9").then((r) => setPlants(r.data || []));
  }, []);

  const poweredBy = s.embed_powered_by || "wildkräuter.lu";
  const siteUrl = window.location.origin;

  return (
    <div className="p-4" data-testid="embed-page">
      <div className="grid grid-cols-3 gap-3">
        {plants.map((p) => (
          <a
            key={p.id}
            href={`/plants/${p.slug}`}
            target="_top"
            className="plant-card overflow-hidden block"
          >
            <img src={p.image_url} alt={p.name_de} className="w-full h-32 object-cover" />
            <div className="p-3">
              <div className="text-sm font-medium truncate">{p.name_de}</div>
              <div className="italic text-[10px] opacity-70 truncate">{p.name_lat}</div>
              <div className="mt-1"><PlantBadge category={p.category} /></div>
            </div>
          </a>
        ))}
      </div>
      <div className="text-[10px] text-center opacity-60 mt-3" data-testid="embed-powered-by">
        powered by <a href={siteUrl} target="_top" className="underline">{poweredBy}</a>
      </div>
    </div>
  );
}
